module.exports = __webpack_public_path__ + "media/images/user/favicons/android-chrome-512x512-0b94c8212beeaa2808de85ab1d53b9da.png";